<template>
  <div class="orderList-view view pa24" :key="i18nUpdateKey">
    <el-row :gutter="24">
      <el-col :xl="5" :lg="5" style="width: 20%;">
        <div class="d-flex align-items-center mt10 nowrap">
          {{ $t('order', 'orderNumber') }}：
          <el-input v-model="ordersNo" :placeholder="$t('order', 'orderNumber')"></el-input>
        </div>
      </el-col>
      <el-col :xl="5" :lg="5" style="width: 20%;">
        <div class="d-flex align-items-center mt10 nowrap">
          {{ $t('order', 'orderDate') }}：
          <el-date-picker style="width: 100%" v-model="pickerValue" align="right" type="date" :placeholder="$t('order', 'orderDate')"
            :picker-options="pickerOptions" />
        </div>
      </el-col>
      <el-col :xl="5" :lg="5" style="width: 20%;">
        <div class="d-flex align-items-center mt10 nowrap">
          {{ $t('order', 'customerName') }}：
          <el-input v-model="nickeName" :placeholder="$t('order', 'customerName')"></el-input>
        </div>
      </el-col>
      <el-col :xl="5" :lg="5" style="width: 20%;">
        <div class="d-flex align-items-center mt10 nowrap">
          {{ $t('order', 'customerPhone') }}：
          <el-input v-model="phone" :placeholder="$t('order', 'customerPhone')"></el-input>
        </div>
      </el-col>
      <el-col :xl="5" :lg="5" style="width: 20%;">
        <div class="d-flex align-items-center mt10 nowrap">
          {{ $t('order', 'productName') }}：
          <el-input v-model="goodsName" :placeholder="$t('order', 'productName')"></el-input>
        </div>
      </el-col>
      <el-col :xl="24" :lg="24">
        <div class="flex-a-c pt10">
          <div>
            {{ $t('order', 'orderStatus') }}：
            <el-radio style="margin-right: 0;" v-model="orderStatusValue" :label="item.label"
              v-for="(item, index) in orderStatus" :key="index" border>
              {{ item.text }}
            </el-radio>
          </div>
          <el-button type="primary" class="ml10" @click="selectOrdersInfoPcAsync">{{ $t('common', 'search') }}</el-button>
          <!-- <div>
            <el-button style="padding-top: 0; padding-bottom: 0" class="export" @click="exportOrder">
              <div
                style="height: 32px"
                class="d-flex align-items-center justify-content-center"
              >
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-save"></use>
                </svg>
                <span>导出</span>
              </div>
            </el-button>
          </div> -->
        </div>
      </el-col>
    </el-row>
    <commonTable ref="commonTable" :tableData="tableData" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage" :loading="loading" :total="total" :row-class-name="tableRowClassName">
      <template v-slot:table>
        <el-table-column prop="ordersNo" align="center" width="165" :label="$t('order', 'orderNumber')" />
        <el-table-column prop="nickeName" align="center" :label="$t('order', 'customerName')" />
        <el-table-column prop="phone" align="center" width="116" :label="$t('order', 'customerPhone')" />
        <el-table-column prop="receiveName" align="center" :label="$t('order', 'receiveName')" />
        <el-table-column prop="receivePhone" align="center" width="116" :label="$t('order', 'receivePhone')" />
        <el-table-column prop="locationAddress" align="center" width="200px" show-overflow-tooltip :label="$t('order', 'deliveryAddress')">
          <template slot-scope="scope">
            <span>{{ scope.row.locationAddress + scope.row.detailedAddress }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" align="center" width="150" show-overflow-tooltip :label="$t('order', 'productName')">
          <template slot-scope="scope">
            <div v-if="scope.row.ordersModelList && scope.row.ordersModelList.length > 0">
              <div v-for="(item, index) in scope.row.ordersModelList" :key="index">
                {{ item.goodsName }}
              </div>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderPrice" align="center" :label="$t('order', 'orderAmount')" />
        <el-table-column prop="specAttribute" align="center" width="200" show-overflow-tooltip :label="$t('order', 'purchaseInfo')">
          <template slot-scope="scope">
            <div v-if="scope.row.ordersModelList && scope.row.ordersModelList.length > 0">
              <div v-for="(item, index) in scope.row.ordersModelList" :key="index">
                {{ formatSpecWithNum(item) }}
              </div>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" width="165" align="center" show-overflow-tooltip :label="$t('order', 'orderDate')">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | setDate() }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryTime" width="165" align="center" show-overflow-tooltip :label="$t('order', 'deliveryTime')">
          <template slot-scope="scope">
            <span v-if="scope.row.deliveryTime">{{ scope.row.deliveryTime | setDate() }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="assembleId" align="center" :label="$t('order', 'orderStatus')">
          <template slot-scope="scope">
            <span>{{ getOrderStateText(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="resaleLevel" align="center" width="120" :label="$t('order', 'resaleOrder')">
          <template slot-scope="scope">
            <!-- 上级订单行：显示空白 -->
            <template v-if="scope.row.isParentOrder">
              <span>-</span>
            </template>
            <!-- 正常订单行：显示查看详情 -->
            <div v-else-if="scope.row.resaleLevel && scope.row.resaleLevel > 0" style="display: flex; align-items: center; justify-content: center;">
              <i 
                :class="expandedRows.includes(scope.row.ordersId) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" 
                class="arrow-icon"
                @click.stop="toggleParentOrder(scope.row)">
              </i>
              <el-button 
                type="text" 
                size="mini" 
                @click.stop="toggleParentOrder(scope.row)"
                :loading="scope.row.isLoading">
                {{ $t('order', 'viewDetails') }}
              </el-button>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="refundRemark" align="center" width="120" show-overflow-tooltip :label="$t('order', 'refundReason')">
          <template slot-scope="scope">
            <span v-if="!scope.row.isParentOrder">{{ scope.row.refundRemark }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" align="center" width="120" show-overflow-tooltip :label="$t('customer', 'remark')">
          <template slot-scope="scope">
            <span v-if="!scope.row.isParentOrder">{{ scope.row.remark }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="assembleId" align="center" :label="$t('order', 'orderSource')">
          <template slot-scope="scope">
            <span v-if="!scope.row.isParentOrder">{{ scope.row.assembleId ? $t('order', 'groupBuyOrder') : $t('order', 'personalOrder') }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column width="140" align="center" :label="$t('common', 'edit')">
          <template slot-scope="scope">
            <template v-if="!scope.row.isParentOrder">
              <span class="cblue hover_pointer" v-if="scope.row.orderState == 0"
                @click="delExpireOrder(scope.row.ordersId)">
                {{ $t('common', 'delete') }}
              </span>
            <span class="cblue hover_pointer" v-else-if="scope.row.orderState == 1"
              @click="onConfirmMsg(scope.row.ordersId, 5, 1)">
              {{ $t('order', 'cancelOrder') }}
            </span>
            <span class="cblue hover_pointer" v-else-if="scope.row.orderState == 2 && scope.row.refundState == 1 && !(scope.row.resaleLevel > 0)"
              @click="onConfirmMsg(scope.row.ordersId, 3, 1)">
              {{ $t('order', 'confirmShipment') }}
            </span>
              <template v-else-if="scope.row.refundState == 2">
                <span class="cblue hover_pointer" @click="onConfirmMsg(scope.row.ordersId, 1, 2)">
                  {{ $t('order', 'rejectRefund') }}
                </span>
                <span class="cblue hover_pointer" @click="onConfirmMsg(scope.row.ordersId, 3, 2)">
                  {{ $t('order', 'confirmRefund') }}
                </span>
              </template>
              <template v-else>-</template>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>
<script>
import commonTable from "@/components/common/commonTable";
import {
  selectOrdersInfoPc,
  updateOrderStatePc,
  delOrders,
  updateRefundState,
  exportOrdersInfoPc,
  getParentOrderPc
} from "@/api/order";
import { getDataTimeSec, isProduction } from "@/utils";
import i18nMixin from '@/mixins/i18nMixin';
export default {
  name: "orderList",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      orderStatusValue: '', //订单状态
      pickerValue: "", //下单时间
      ordersNo: '',//订单编号
      goodsName: '',//商品名称
      phone: '',
      nickeName: '',
      receiveName: '',
      searchCondition: '', //搜索时间
      spanArr: [], //二维数组，用于存放单元格合并规则
      position: 0, //用于存储相同项的开始index
      loading: '',
      total: 0, //总条数
      currentPage: 1, //当前页数
      start: '',
      end: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      orderStatus: [],
      tableData: [],
      expandedRows: [], // 记录展开的行
    };
  },
  created() {
    // 初始化订单状态和类型选项
    this.initOrderOptions();
    
    this.selectOrdersInfoPcAsync();
    this.rowspan(0, "orderNumber");
    this.rowspan(8, "nameOrtelephone");
    this.rowspan(9, "orderType");
  },
  mounted() {
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.initOrderOptions(); // 重新初始化选项
      this.$forceUpdate();
    });
  },
  watch: {
    pickerValue(val, old) {
      console.log(val)
      if (val == null) {
        return this.searchCondition = ''
      }
      this.searchCondition = getDataTimeSec(val, 'yy-mm-dd') + " 00:00:00"
    }
  },
  filters: {
    setState(item) {
  
      let obj = {
        1: {
          0: '已失效',
          1: '待付款',
          2: '待发货',
          3: '待收货',
          4: '已完成',
          5: '订单取消',
          6: '退款成功',
        },
        2: '退款中',
        3: '退款成功',
      };
      return item.refundState == 1 ? obj[item.refundState][item.orderState] : obj[item.refundState];
    },
    setDate(date) {
      return getDataTimeSec(date)
    }
  },
  computed: {
    isProduction() {
      return isProduction();
    }
  },
  methods: {
    // 格式化规格显示（带数量）
    formatSpecWithNum(item) {
      if (!item) return '-';
      
      let specNames = [];
      let specAttrs = [];
      
      // 处理 specName
      if (item.specName) {
        try {
          // 尝试解析为 JSON 数组
          const parsed = JSON.parse(item.specName);
          if (Array.isArray(parsed)) {
            specNames = parsed.filter(s => s); // 过滤空值
          } else if (item.specName) {
            specNames = [item.specName];
          }
        } catch (e) {
          // 如果不是 JSON，直接使用
          if (item.specName) {
            specNames = item.specName.split(',').map(s => s.trim()).filter(s => s);
          }
        }
      }
      
      // 处理 specAttribute
      if (item.specAttribute) {
        try {
          // 尝试解析为 JSON 数组
          const parsed = JSON.parse(item.specAttribute);
          if (Array.isArray(parsed)) {
            specAttrs = parsed.filter(s => s); // 过滤空值
          } else if (item.specAttribute) {
            specAttrs = [item.specAttribute];
          }
        } catch (e) {
          // 如果不是 JSON，直接使用
          if (item.specAttribute) {
            specAttrs = item.specAttribute.split(',').map(s => s.trim()).filter(s => s);
          }
        }
      }
      
      // 组合显示
      let specText = '';
      if (specNames.length > 0 && specAttrs.length > 0) {
        // 一一对应组合 specName 和 specAttribute
        const combined = [];
        const maxLength = Math.max(specNames.length, specAttrs.length);
        for (let i = 0; i < maxLength; i++) {
          const name = specNames[i] || '';
          const attr = specAttrs[i] || '';
          if (name && attr) {
            combined.push(`${name}-${attr}`);
          } else if (attr) {
            combined.push(attr);
          } else if (name) {
            combined.push(name);
          }
        }
        specText = combined.join(', ');
      } else if (specAttrs.length > 0) {
        specText = specAttrs.join(', ');
      } else if (specNames.length > 0) {
        specText = specNames.join(', ');
      }
      
      // 添加数量
      const num = item.num || 1;
      if (specText) {
        return `${specText} x${num}`;
      } else {
        return `x${num}`;
      }
    },
    // 获取订单状态文本（多语言支持）
    getOrderStateText(item) {
      const stateMap = {
        1: {
          0: this.$t('order', 'expired'),
          1: this.$t('order', 'pendingPayment'),
          2: this.$t('order', 'pendingShipment'),
          3: this.$t('order', 'pendingReceipt'),
          4: this.$t('order', 'completed'),
          5: this.$t('order', 'transactionCancelled'),
          6: this.$t('order', 'refundSuccessful'),
        },
        2: this.$t('order', 'refunding'),
        3: this.$t('order', 'refunded'),
      };
      return item.refundState == 1 ? stateMap[item.refundState][item.orderState] : stateMap[item.refundState];
    },



    // 初始化订单选项
    initOrderOptions() {
      this.orderStatus = [
        //订单状态
        { text: this.$t('order', 'allOrders'), label: "" },
        { text: this.$t('order', 'pendingPayment'), label: 1 },
        { text: this.$t('order', 'pendingShipment'), label: 2 },
        { text: this.$t('order', 'pendingReceipt'), label: 3 },
        { text: this.$t('order', 'completed'), label: 4 },
      ];
    },


    //导出
    exportOrder() {
      let data = {
        orderState: ''
      }
      exportOrdersInfoPc(data).then(res => {
        let blob = new Blob(["\ufeff", res], { type: 'text/csv,charset=UTF-8' });
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          window.navigator.msSaveOrOpenBlob(blob, 'fileName.csv');
        } else {
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          link.setAttribute('download', 'fileName.csv');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        let link = document.createElement('a');
        let url = window.URL.createObjectURL(res);
        link.href = url;
        link.download = this.$t('order', 'orderList') + '.xls';
        link.click();
        window.URL.revokeObjectURL(url);
      })
        .catch(err => {
          console.log(err)
        })
    },
    rowspan(idx, prop) {
      this.spanArr[idx] = [];
      this.position = 0;
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr[idx].push(1);
          this.position = 0;
        } else {
          if (this.tableData[index][prop] === this.tableData[index - 1][prop]) {
            this.spanArr[idx][this.position] += 1; //有相同项
            this.spanArr[idx].push(0); // 名称相同后往数组里面加一项0
          } else {
            this.spanArr[idx].push(1); //同列的前后两行单元格不相同
            this.position = index;
          }
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if ([0, 8, 9].includes(columnIndex)) {
        const _row = this.spanArr[columnIndex][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    async selectOrdersInfoPcAsync() {
      this.loading = true
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        createTimes: this.searchCondition,
        orderState: this.orderStatusValue,
        ordersNo: this.ordersNo,
        goodsName: this.goodsName,
        phone: this.phone,
        nickeName: this.nickeName,
        receiveName: this.receiveName,
      };
      const result = await selectOrdersInfoPc(data);
      this.loading = false
      if (result.data) {
        this.tableData = result.data.pageInfo.list;
        this.total = result.data.pageInfo.total
        this.tableData.forEach(v => {
          v.orderPrice = (v.orderPrice / 100).toFixed(2)
        })
      } else {
        this.tableData = []
      }
    },
    //当前页变更
    handleCurrentChange(num) {
      this.pageNum = num;
      this.selectOrdersInfoPcAsync();
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.currentPage = 1;
      this.selectOrdersInfoPcAsync();
    },
    //删除订单
    delExpireOrder(id) {
      this.$confirm(this.$t('order', 'deleteOrderConfirm'), this.$t('common', 'info'), {
        confirmButtonText: this.$t('common', 'confirm'),
        cancelButtonText: this.$t('common', 'cancel'),
      })
        .then(() => {
          delOrders({ ordersId: id })
            .then(res => {
              this.$message({
                type: "success",
                message: this.$t('common', 'success'),
              });
              this.selectOrdersInfoPcAsync()
            })
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //修改订单状态
    onConfirmMsg(ordersId, state, type) {
      let obj = {
        1: {
          5: this.$t('order', 'cancelOrderConfirm'),
          3: this.$t('order', 'confirmShipmentConfirm'),
        },
        2: {
          1: this.$t('order', 'rejectRefundConfirm'),
          3: this.$t('order', 'confirmRefundConfirm'),
        }
      };
      let text = obj[type][state];
      this.$confirm(text, this.$t('common', 'info'), {
        confirmButtonText: this.$t('common', 'confirm'),
        cancelButtonText: this.$t('common', 'cancel'),
      })
        .then(() => {
          if (type == 1) {
            this.changeOrderState(ordersId, state);
          } else {
            this.changeRefund(ordersId, state);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeOrderState(id, state) {
      updateOrderStatePc({
        orderState: state,
        ordersId: id,
      })
        .then(res => {
          this.$message({
            type: "success",
            message: this.$t('common', 'success'),
          });
          this.selectOrdersInfoPcAsync()
        })
    },
    changeRefund(id, state) {
      updateRefundState({
        refundState: state,
        ordersId: id,
      })
        .then(res => {
          this.$message({
            type: "success",
            message: this.$t('common', 'success'),
          });
          this.selectOrdersInfoPcAsync()
        })
        .catch(err => {
          if (err.code === 201) {
            this.$message({
              type: "error",
              message: err.message || this.$t('order', 'refundOperationFailed'),
            });
          } else {
            this.$message({
              type: "error",
              message: err.message || this.$t('common', 'operationFailed'),
            });
          }
          console.error(err);
        })
    },
    // 切换上级订单显示
    async toggleParentOrder(row) {
      // 防止重复点击
      if (row.isLoading) {
        return;
      }
      
      const isExpanded = this.expandedRows.includes(row.ordersId);
      
      // 如果已经展开，则收起（移除插入的上级订单行）
      if (isExpanded) {
        this.removeParentOrderRows(row.ordersId);
        this.expandedRows = this.expandedRows.filter(id => id !== row.ordersId);
        return;
      }
      
      // 如果未展开，加载并插入上级订单数据
      if (!row.parentOrderData || row.parentOrderData.length === 0) {
        // 立即显示 loading 状态
        this.$set(row, 'isLoading', true);
        
        try {
          const result = await getParentOrderPc({ ordersId: row.ordersId });
          this.$set(row, 'isLoading', false);
          
          if (result.data) {
            // 处理返回的数据
            let orderData = [];
            if (result.data.pageInfo && result.data.pageInfo.list) {
              orderData = result.data.pageInfo.list;
            } else if (Array.isArray(result.data)) {
              orderData = result.data;
            } else if (result.data.ordersId) {
              orderData = [result.data];
            }
            
            // 处理价格格式并标记为上级订单
            orderData.forEach(v => {
              if (v.orderPrice) {
                v.orderPrice = (v.orderPrice / 100).toFixed(2);
              }
              v.isParentOrder = true; // 标记为上级订单
              v.parentOf = row.ordersId; // 记录所属的主订单ID
            });
            
            // 保存到 row 对象中
            this.$set(row, 'parentOrderData', orderData);
            
            // 插入到 tableData 中
            this.insertParentOrderRows(row.ordersId, orderData);
            this.expandedRows.push(row.ordersId);
          } else {
            this.$message.warning(this.$t('order', 'noParentOrder'));
            return;
          }
        } catch (err) {
          this.$set(row, 'isLoading', false);
          this.$message.error(this.$t('order', 'getParentOrderFailed'));
          console.error(err);
          return;
        }
      } else {
        // 数据已存在，直接插入
        this.insertParentOrderRows(row.ordersId, row.parentOrderData);
        this.expandedRows.push(row.ordersId);
      }
    },
    
    // 插入上级订单行到 tableData 中
    insertParentOrderRows(ordersId, parentOrderData) {
      const index = this.tableData.findIndex(item => item.ordersId === ordersId);
      if (index !== -1) {
        // 在当前行后面插入上级订单数据
        this.tableData.splice(index + 1, 0, ...parentOrderData);
      }
    },
    
    // 移除上级订单行
    removeParentOrderRows(ordersId) {
      // 过滤掉属于该订单的所有上级订单行
      this.tableData = this.tableData.filter(item => item.parentOf !== ordersId);
    },
    
    // 表格行样式类名
    tableRowClassName({ row }) {
      return row.isParentOrder ? 'parent-order-row' : '';
    }
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  }
};
</script>
<style scoped lang='scss'>
.orderList-view {
  padding-top: 14px;
}
.el-radio--small.is-bordered {
  padding: 8px 8px 0px;
}
.el-radio--mini.is-bordered .el-radio__label, .el-radio--small.is-bordered .el-radio__label {
  padding-left: 2px;
}

// 箭头图标统一样式
::v-deep .arrow-icon {
  font-size: 14px;
  margin-right: 5px;
  color: #51CDCB;
  cursor: pointer;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.15);
    color: #3AB9B7;
  }
}

// 上级订单行样式
::v-deep .parent-order-row {
  background-color: #E8FAF9 !important;
  font-style: italic;
  animation: slideIn 0.3s ease-out;
  
  &:hover > td {
    background-color: #D4F5F4 !important;
  }
  
  // 前12列正常显示
  td:nth-child(1), td:nth-child(2), td:nth-child(3), 
  td:nth-child(4), td:nth-child(5), td:nth-child(6),
  td:nth-child(7), td:nth-child(8), td:nth-child(9),
  td:nth-child(10), td:nth-child(11), td:nth-child(12) {
    color: #606266;
  }
  
  // 后5列显示灰色背景
  td:nth-child(13), td:nth-child(14), td:nth-child(15),
  td:nth-child(16), td:nth-child(17) {
    background-color: #fafafa !important;
  }
}

// 滑入动画
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
